import { all, put, call, takeLatest } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  recordAlertsLoadSuccess,
  recordAlertsLoadFailure,
  RECORD_ALERTS_LOAD,
  AlertsLoadAction
} from './actions'

type GenericObject = { [key: string]: any }

function extractFilter(filter) {
  const result = {}
  if (filter == null) {
    return result
  }

  if (filter.startDate != null) {
    result['filter[RecordDateFrom]'] = filter.startDate.toISOString()
  }
  if (filter.endDate != null) {
    result['filter[RecordDateTo]'] = filter.endDate.toISOString()
  }

  return result
}

function* recordAlertsLoadSaga(action: AlertsLoadAction) {
  const { accountId, projectId, filter } = action

  try {
    let recordAlerts: GenericObject[] = []
    const response: { data: GenericObject[] } = yield call(() =>
      axios.get(`/accounts/${accountId}/projects/${projectId}/recordalerts`, {
        params: { ...extractFilter(filter) }
      })
    )

    recordAlerts = response && response.data ? [...response.data] : []

    yield put(recordAlertsLoadSuccess(accountId, projectId, recordAlerts))
  } catch (error) {
    console.error(error)
    yield put(recordAlertsLoadFailure(accountId, projectId, error))
  }
}

export function* watch() {
  yield all([takeLatest(RECORD_ALERTS_LOAD, recordAlertsLoadSaga)])
}
